module.exports = __webpack_public_path__ + "img/rating-page-background.60649770.png";